if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // オプション情報を取得
        const sectionId = this.dataset.sectionId;
        const optionsBundle = this.getOptionsBundle(sectionId);
        
        // オプションが選択されているか確認
        let hasSelectedOptions = false;
        if (optionsBundle) {
          const options = optionsBundle.getOptions();
          hasSelectedOptions =
            options.engraving === 'yes' ||
            options.birthstone === 'yes' ||
            options.normalClaw === 'yes' ||
            options.slideAdjuster === 'yes' ||
            options.identificationCard === 'yes' ||
            options.certificate === 'yes';
          
          // オプションが選択されている場合のみバリデーション実行
          if (hasSelectedOptions && !optionsBundle.validateOptions()) {
            // バリデーションエラーがある場合は送信を停止
            // 連続クリック防止のため、短時間ボタンを無効化
            this.submitButton.setAttribute('aria-disabled', true);
            setTimeout(() => {
              this.submitButton.removeAttribute('aria-disabled');
            }, 500);
            return false;
          }
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        
        if (hasSelectedOptions) {
          // オプションが選択されている場合は、items配列で一括追加
          this.addItemsWithOptions(sectionId, optionsBundle);
        } else {
          // オプションが選択されていない場合は従来の処理
          this.addSingleItem();
        }
      }

      getOptionsBundle(sectionId) {
        const optionsContainer = document.querySelector(`.product-options[data-section-id="${sectionId}"]`);
        if (!optionsContainer) return null;

        // ProductOptionsBundleインスタンスを取得または作成
        if (!window.productOptionsBundleInstance) {
          const settings = this.getOptionsSettings(sectionId);
          window.productOptionsBundleInstance = new window.ProductOptionsBundle(sectionId, settings);
        }
        return window.productOptionsBundleInstance;
      }

      getOptionsSettings(sectionId) {
        // セクション設定から手数料variant_idを取得
        const sectionElement = document.getElementById(`MainProduct-${sectionId}`);
        if (!sectionElement) return {};

        return {
          engravingVariantId: sectionElement.dataset.engravingVariantId || null,
          birthstoneVariantId: sectionElement.dataset.birthstoneVariantId || null
        };
      }

      addItemsWithOptions(sectionId, optionsBundle) {
        const variantId = this.variantIdInput.value;
        const quantity = parseInt(this.form.querySelector('[name="quantity"]')?.value || '1', 10);
        const options = optionsBundle.getOptions();
        const items = optionsBundle.getCartItems(variantId, quantity, options);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['Content-Type'] = 'application/json';

        const sectionsToRender = this.getSectionsToRender();
        // cart-notificationとcart-icon-bubbleを確実に含める
        const sectionIds = [];
        sectionsToRender.forEach((section) => {
          if (section.section) {
            sectionIds.push(section.section);
          } else if (section.id) {
            sectionIds.push(section.id);
          }
        });
        
        // cart-notification-productが含まれていない場合は追加
        if (!sectionIds.includes('cart-notification-product')) {
          sectionIds.push('cart-notification-product');
        }
        
        // cart-icon-bubbleが含まれていない場合は追加
        if (!sectionIds.includes('cart-icon-bubble')) {
          sectionIds.push('cart-icon-bubble');
        }
        
        const body = {
          items: items,
          sections: sectionIds.length > 0 ? sectionIds.join(',') : undefined,
          sections_url: sectionIds.length > 0 ? window.location.pathname : undefined
        };

        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = JSON.stringify(body);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            this.handleCartResponseWithOptions(response, variantId, sectionId, optionsBundle);
          })
          .catch((e) => {
            console.error('Cart add error:', e);
            this.handleErrorMessage('カートへの追加に失敗しました。もう一度お試しください。');
            this.resetSubmitButton();
          });
      }
      
      handleCartResponseWithOptions(response, variantId, sectionId, optionsBundle) {
        // エラーチェック: statusが'error'またはerrorsが存在する場合
        if (response.status === 'error' || response.errors) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: variantId,
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description || 'カートへの追加に失敗しました。もう一度お試しください。');
          this.error = true;
          this.resetSubmitButton();
          return;
        }

        // カート通知を表示（オプションがある場合でも）
        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        // レスポンスにkeyがない場合、最初のアイテムのkeyを使用
        if (!response.key && response.items && response.items.length > 0) {
          response.key = response.items[0].key;
        }
        
        // sectionsが存在しない場合はエラー
        if (!response.sections) {
          // sectionsがない場合でもカートには追加されている可能性があるため、カートページへ遷移
          window.location = window.routes.cart_url;
          return;
        }

        const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
        if (!this.error) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: variantId,
            cartData: response,
          }).then(() => {
            CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
          });
        }
        this.error = false;
        
        // cart:addedイベントを発火（カートアイコン更新のため）
        document.dispatchEvent(new CustomEvent('cart:added', { detail: { cart: response } }));
        
        // カート通知の表示とカートアイコンの更新
        CartPerformance.measure("add:paint-updated-sections", () => {
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  if (this.cart && this.cart.renderContents && response.sections) {
                    try {
                      this.cart.renderContents(response);
                    } catch (e) {
                      console.error('カート通知の表示に失敗:', e);
                      // エラーが発生してもカートには追加されているため、カートページへ遷移
                      window.location = window.routes.cart_url;
                    }
                  }
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            if (this.cart && this.cart.renderContents && response.sections) {
              try {
                this.cart.renderContents(response);
              } catch (e) {
                console.error('カート通知の表示に失敗:', e);
                // エラーが発生してもカートには追加されているため、カートページへ遷移
                window.location = window.routes.cart_url;
              }
            }
          }
        });
        
        this.resetSubmitButton();
      }

      addSingleItem() {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        // カートアイコンの更新のために、cart-icon-bubbleセクションを常に含める
        const sectionsToRender = this.getSectionsToRender();
        const sectionIds = sectionsToRender.map((section) => section.section || section.id).filter(Boolean);
        if (sectionIds.length > 0) {
          formData.append('sections', sectionIds.join(','));
          formData.append('sections_url', window.location.pathname);
        }
        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            const variantId = formData.get('id');
            this.handleCartResponse(response, variantId);
          })
          .catch((e) => {
            console.error('Cart add error:', e);
            this.handleErrorMessage('カートへの追加に失敗しました。もう一度お試しください。');
            this.resetSubmitButton();
          });
      }

      handleCartResponse(response, variantId) {
        // エラーチェック: /cart/add.jsのレスポンスは単一アイテムのオブジェクトを返す
        // エラーの場合はstatusが'error'またはerrorsが存在する
        // 成功の場合はid、key、variant_idなどが存在する
        const isError = response.status === 'error' || response.errors;
        const isSuccess = response.id || response.key || response.variant_id;
        
        if (isError && !isSuccess) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: variantId,
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description || 'カートへの追加に失敗しました。もう一度お試しください。');

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) {
            this.error = true;
            this.resetSubmitButton();
            return;
          }
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButtonText.classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          this.resetSubmitButton();
          return;
        }
        
        // 成功の場合、レスポンスをカート形式に変換
        // /cart/add.jsは単一アイテムを返すが、カート通知にはカート全体の情報が必要
        // そのため、カート情報を取得する必要がある
        if (isSuccess && !response.sections) {
          // sectionsがない場合は、カート情報を取得してから通知を表示
          fetch(`${routes.cart_url}.js`)
            .then((cartResponse) => cartResponse.json())
            .then((cartData) => {
              // カート情報を取得したら、sectionsを取得
              const sectionsToRender = this.getSectionsToRender();
              const sectionIds = sectionsToRender.map((section) => section.section || section.id).filter(Boolean);
              
              if (sectionIds.length > 0) {
                fetch(`${routes.cart_url}?sections=${sectionIds.join(',')}`)
                  .then((sectionsResponse) => sectionsResponse.text())
                  .then((sectionsHtml) => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(sectionsHtml, 'text/html');
                    const sections = {};
                    sectionIds.forEach((id) => {
                      const element = doc.getElementById(id);
                      if (element) {
                        sections[id] = element.outerHTML;
                      }
                    });
                    
                    const fullResponse = {
                      ...cartData,
                      sections: sections,
                      key: response.key || (cartData.items && cartData.items.length > 0 ? cartData.items[0].key : null)
                    };
                    this.processCartSuccess(fullResponse, variantId);
                  })
                  .catch((e) => {
                    console.error('セクション取得エラー:', e);
                    // セクション取得に失敗してもカートには追加されているため、カートページへ遷移
                    window.location = window.routes.cart_url;
                  });
              } else {
                this.processCartSuccess({ ...cartData, key: response.key }, variantId);
              }
            })
            .catch((e) => {
              console.error('カート情報取得エラー:', e);
              // カート情報取得に失敗してもカートには追加されているため、カートページへ遷移
              window.location = window.routes.cart_url;
            });
          return;
        }
        
        this.processCartSuccess(response, variantId);
      }
      
      processCartSuccess(response, variantId) {
        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
        if (!this.error) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: variantId,
            cartData: response,
          }).then(() => {
            CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
          });
        }
        this.error = false;
        
        // cart:addedイベントを発火（カートアイコン更新のため）
        document.dispatchEvent(new CustomEvent('cart:added', { detail: { cart: response } }));
        
        // カート通知の表示とカートアイコンの更新
        CartPerformance.measure("add:paint-updated-sections", () => {
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  if (this.cart && this.cart.renderContents && response.sections) {
                    try {
                      this.cart.renderContents(response);
                    } catch (e) {
                      console.error('カート通知の表示に失敗:', e);
                      // エラーが発生してもカートには追加されているため、カートページへ遷移
                      window.location = window.routes.cart_url;
                    }
                  }
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            if (this.cart && this.cart.renderContents && response.sections) {
              try {
                this.cart.renderContents(response);
              } catch (e) {
                console.error('カート通知の表示に失敗:', e);
                // エラーが発生してもカートには追加されているため、カートページへ遷移
                window.location = window.routes.cart_url;
              }
            }
          }
        });
        
        this.resetSubmitButton();
      }

      resetSubmitButton() {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner').classList.add('hidden');
      }

      onSubmitHandlerOld(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        // カートアイコンの更新のために、cart-icon-bubbleセクションを常に含める
        const sectionsToRender = this.getSectionsToRender();
        const sectionIds = sectionsToRender.map((section) => section.section || section.id).filter(Boolean);
        if (sectionIds.length > 0) {
          formData.append('sections', sectionIds.join(','));
          formData.append('sections_url', window.location.pathname);
        }
        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            const variantId = formData.get('id');
            this.handleCartResponse(response, variantId);
          })
          .catch((e) => {
            console.error('Cart add error:', e);
            this.handleErrorMessage('カートへの追加に失敗しました。もう一度お試しください。');
            this.resetSubmitButton();
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      getSectionsToRender() {
        const sections = [];
        
        // cart-notificationまたはcart-drawerが存在する場合は、そのセクションも含める
        if (this.cart && this.cart.getSectionsToRender) {
          sections.push(...this.cart.getSectionsToRender());
        }
        
        // カートアイコン更新のためにcart-icon-bubbleセクションを常に含める
        // cart-notificationのgetSectionsToRender()と同じ形式で追加
        const cartIconBubbleExists = sections.some(section => section.id === 'cart-icon-bubble');
        if (!cartIconBubbleExists) {
          sections.push({ id: 'cart-icon-bubble' });
        }
        
        return sections;
      }
    }
  );
}
